@if (modalConfig) {
  <div
    [class]="modalClass"
    #modalWrapper
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true">
    <div class="flex justify-between items-center py-0 border-b border-b-gray-200 dark:border-b-dark-border h-[72px]">
      @if (modalConfig.title) {
        <div class="text-xl text-secondary px-4">
          {{ modalConfig.title | translate }}
        </div>
      }

      <a
        href="#"
        class="flex justify-center items-center text-secondary hover:bg-gray-100 dark:hover:bg-dark-hover ease-in-out transition-all border-l border-l-gray-200 dark:border-l-dark-border h-[72px] w-[72px]"
        (click)="$event.preventDefault(); cancel()"
      >
        <lucide-icon [name]="X"></lucide-icon>
      </a>
    </div>
    <!-- Alert -->
   <app-alert-service-wrapper area="modal"></app-alert-service-wrapper>
    <!-- Body -->
    <div class="px-4 py-4 flex-grow overflow-y-auto">
      <div #modalContainer></div>
    </div>
    @if (modalConfig.actions && modalConfig.actions.length > 0) {
      <div class="flex justify-end gap-2 mt-4 pt-4 border-t border-t-gray-100 dark:border-t-dark-border p-4">
        @for (action of modalConfig.actions; track action.label) {
          <button
            appButton
            [type]="action.type ?? 'primary'"
            (click)="handleAction(action)">
            {{ action.label | translate }}
          </button>
        }
      </div>
    }
  </div>
}
